import { Component, Input, OnInit } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { BillableService } from 'src/app/core/service/billable.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';
import { PayerBillingService } from 'src/app/core/service/payer-billing.service';

@Component({
  standalone: false,
  selector: 'app-case-detail-billable',
  templateUrl: './case-detail-billable.component.html',
  styleUrls: ['./case-detail-billable.component.scss']
})
export class CaseDetailBillableComponent implements OnInit
{
  public currentMemberId: number;
  public currentCaseBillableId: number;
  public billablesCount: number;

  public viewBillableItems: GridViewManager;
  public pageSizes = [5, 10, 25, 50, 100];
  private billableStatuses = [];
  private adjustmentTypes = [];

  constructor(
    private billableService: BillableService,
    private messageHandlerService: MessageHandlerService,
    private payerBillingService: PayerBillingService,
    public intl: IntlService)
  {
  }

  @Input() public set memberId(memberId: number)
  {
    if (memberId !== undefined)
    {
      this.currentMemberId = memberId;
    }
  }

  @Input() public set caseBillableId(caseBillableId: number)
  {
    if (caseBillableId !== undefined)
    {
      this.currentCaseBillableId = caseBillableId;

      this.viewBillableItems = new GridViewManager(99999);
      this.viewBillableItems.setData([]);

      this.loadCaseBillableByParentId();
    }
  }

  public ngOnInit(): void
  {
    this.billableStatuses = this.payerBillingService.invoiceItemStatuses;
    this.adjustmentTypes = this.payerBillingService.adjustmentTypes;
  }

  public getCaseBillableText(billableValue: string): string 
  {
    const billableStatus = this.billableStatuses.find(x => x.value === billableValue);
    if (billableStatus)
    {
      billableValue = billableStatus.label;
    }
    return billableValue;
  }

  public getAdjustmentTypeText(adjustmentType: string): string 
  {
    const billableStatus = this.adjustmentTypes.find(x => x.value === adjustmentType);
    if (billableStatus)
    {
      adjustmentType = billableStatus.label;
    }
    return adjustmentType;
  }

  private loadCaseBillableByParentId(): void
  {
    this.billableService.getCaseBillableByParentId(this.currentMemberId, this.currentCaseBillableId).subscribe({
      next: (data: any) =>
      {
        this.viewBillableItems.setData(data ? data : []);
        this.viewBillableItems.setSort([{ field: 'billableName', dir: 'asc' }]);
        this.billablesCount = this.viewBillableItems.data.length;
      },
      error: (errorMessage) =>
      {
        this.messageHandlerService.displayError(errorMessage);
      }
    });
  }
}
